import { ApiService } from "services/networking";
import { SWRConfiguration } from "swr";
import useSWRImmutable from "swr/immutable";

const fetcher = (url: string) => ApiService.get(url).then((res) => res.data);

export default function useImmutable(key: string, options?: SWRConfiguration) {
   return useSWRImmutable(key, fetcher, options);
}
